module.exports = __webpack_public_path__ + "static/media/3-nuclear.2bc6287a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3-nuclear.svg
// module id = 748
// module chunks = 3